module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listing-page"
  }, [(_vm.tags.length) ? _c('section', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('div', {
      staticClass: "tile"
    }, [_vm._v("\n          " + _vm._s(tag.name) + " "), _c('a', {
      staticClass: "close material-icons",
      on: {
        "click": function($event) {
          return _vm.removeTag(tag)
        }
      }
    }, [_vm._v("cancel")])])
  }), 0), _vm._v(" "), (_vm.tags.length) ? _c('h4', {
    staticClass: "location-count"
  }, [_vm._v(_vm._s(_vm.pls.length) + " Locations")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clear"
  })]) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "categories"
  }, [_c('ul', {
    staticClass: "tabs"
  }, [_vm._l((_vm.filteredCategories), function(category) {
    return (category.name != 'Zip') ? _c('li', {
      class: {
        selected: _vm.tabShowing === category.name
      },
      on: {
        "click": function($event) {
          _vm.tabShowing !== category.name ? _vm.tabShowing = category.name : _vm.tabShowing = false
        }
      }
    }, [_vm._v(_vm._s(category.name))]) : _vm._e()
  }), _vm._v(" "), _c('li', {
    class: {
      selected: _vm.tabShowing === "buildings", buildingshowing: _vm.building
    },
    on: {
      "click": function($event) {
        _vm.tabShowing !== 'buildings' ? _vm.tabShowing = 'buildings' : _vm.tabShowing = false
      }
    }
  }, [(!_vm.building) ? _c('img', {
    attrs: {
      "src": require("../assets/icon-black.png")
    }
  }) : _vm._e(), (_vm.building) ? _c('img', {
    attrs: {
      "src": require("../assets/icon.png")
    }
  }) : _vm._e(), _vm._v(" Buildings")])], 2), _vm._v(" "), _vm._l((_vm.filteredCategories), function(category) {
    return (category.name == _vm.tabShowing) ? _c('div', {
      staticClass: "category"
    }, [_vm._l((category.tags), function(tag, index) {
      return [_c('transition', {
        attrs: {
          "name": "fade"
        }
      }, [_c('span', [(!tag.selected) ? _c('div', {
        staticClass: "tile"
      }, [_c('router-link', {
        attrs: {
          "to": '/browse/' + tag.slug,
          "event": ""
        },
        nativeOn: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.selectTag(tag)
          }
        }
      }, [_c('label', [_vm._v(_vm._s(tag.name) + " "), _c('span', {
        staticClass: "count"
      }, [_vm._v(_vm._s(tag.plcount))])])])], 1) : _vm._e(), _vm._v(_vm._s(' ') + "\n            "), (tag.selected) ? _c('div', {
        staticClass: "tile selected",
        on: {
          "click": function($event) {
            return _vm.removeTag(tag)
          }
        }
      }, [_c('label', [_vm._v(_vm._s(tag.name))])]) : _vm._e(), _vm._v(_vm._s(' ') + "\n            ")])]), _vm._v(_vm._s(' ') + "\n        ")]
    }), _vm._v(" "), (!category.tags.length) ? _c('div', {
      staticClass: "tile no-tags"
    }, [_c('label', [_vm._v("No results")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    }), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    }), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    }), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    }), _vm._v(" "), _c('div', {
      staticClass: "justifier"
    })], 2) : _vm._e()
  })], 2), _vm._v(" "), (_vm.building) ? _c('div', {
    staticClass: "buildingheader"
  }, [_c('h2', [_vm._v(_vm._s(_vm.building.name))])]) : _vm._e(), _vm._v(" "), (_vm.tabShowing != 'buildings') ? _c('div', {
    staticClass: "pl-listing grid"
  }, [_c('BackToTop'), _vm._v(" "), _vm._l((_vm.pls), function(PL, index) {
    return [_c('PLThumb', {
      key: PL.plno,
      attrs: {
        "PL": PL,
        "tagids": _vm.tagids,
        "photofilter": _vm.photoselection,
        "showpullsheet": true,
        "lazy": true
      }
    }), _vm._v(_vm._s(' ') + "\n      ")]
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  })], 2) : _vm._e(), _vm._v(" "), (_vm.tabShowing == 'buildings') ? _c('div', {
    staticClass: "pl-listing grid"
  }, [_c('BackToTop'), _vm._v(" "), _vm._l((_vm.buildings), function(building, index) {
    return [_c('BuildingThumb', {
      key: index,
      attrs: {
        "building": building,
        "lazy": true
      }
    }), _vm._v(_vm._s(' ') + "\n      ")]
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  }), _vm._v(" "), _c('div', {
    staticClass: "justifier"
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c888b022","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Listing.vue
// module id = 214
// module chunks = 1